export default __webpack_public_path__ + "fonts/生态合作.ac30f983ac45a25724189508f12f9dc1.png";